import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { filter } from 'rxjs/operators';
import { CategoryProductsService } from '@shared/service';
import { MainSliderComponent } from '../../../shared/components/main-slider/main-slider.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MainSliderComponent, AsyncPipe],
})
export class BannerComponent implements OnInit {
    private categoryProductsService = inject(CategoryProductsService);

    banners$ = this.categoryProductsService.sliders$.pipe(filter((banners) => banners !== false && (banners?.length ? banners.length > 0 : false)));

    ngOnInit(): void {
        this.categoryProductsService.dispatch();
    }
}
